import { getLocalizedZendeskLink } from "carrot-api/HelpCenterClient"

export interface ZendeskSsoFormParams {
  jwt: string
  postUrl: string
  locale: string
  returnTo: string
}

function buildHiddenZendeskSsoForm({ jwt, postUrl, locale, returnTo }: ZendeskSsoFormParams): HTMLFormElement {
  const localizedReturnTo = getLocalizedZendeskLink(returnTo, locale)

  const form = document.createElement("form")
  form.method = "POST"
  form.action = postUrl
  form.style.display = "none"

  const appendInput = (name: string, value: string) => {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  appendInput("jwt", jwt)
  appendInput("return_to", localizedReturnTo)

  return form
}

/**
 * Submits a hidden form POST to Zendesk's `/access/jwt` endpoint.
 *
 * Zendesk requires a real form submission so that cookies are set on the browser, and cross-origin policy would block
 * an AJAX POST to the Zendesk domain.
 *
 * See: https://support.zendesk.com/hc/en-us/articles/4408845838874-Enabling-JWT-single-sign-on.
 */
export function submitZendeskSsoForm(params: ZendeskSsoFormParams): void {
  const form = buildHiddenZendeskSsoForm(params)
  document.body.appendChild(form)
  form.submit()
}
